import {useQuery, useQueryClient} from "@tanstack/react-query";
import {fetchUserCurrent, USER_CURRENT_KEY} from "../api/public-voissa/users";
import createLink from "../libs/createLink";
import { isCertifEligibleGender } from "../const/certification";
import ability from "../ability";
import _ from "lodash";
import useLogout from "../hooks/useLogout";

const useQueryCurrentUser = ({
        enabled = false,
        onSuccess = () =>{}
    } = {}) =>{
    const queryClient = useQueryClient();
    const logout = useLogout();

    return useQuery(
        [USER_CURRENT_KEY],
        ()=> fetchUserCurrent(),
        {
            staleTime : (1000 * 60 * 2),
            enabled,
            refetchOnWindowFocus: true,
            onSuccess : async (currentUser) =>{
                onSuccess(currentUser);
                if(currentUser?._id) {
                    window._userId = currentUser._id;
                    // Ne pas proposer l'abonnement si l'utilisateur a déjà un plan actif
                    // (Voissa Plus / Max, y compris en trial — le trial pose subscription.plan).
                    if (!currentUser?.subscription?.hasAccess && !currentUser?.subscription?.plan ) {
                        if(isCertifEligibleGender(currentUser.profile.gender)){
                            queryClient.setQueryData([USER_CURRENT_KEY], oldData => {
                                return {
                                    ...oldData,
                                    modalSubscribed : {
                                        modal : false,
                                        modalName : "",
                                        link : createLink("userMeSettingsCertification", oldData)
                                    }
                                }
                            });
                        }
                        else{
                            queryClient.setQueryData([USER_CURRENT_KEY], oldData => {
                                return {
                                    ...oldData,
                                    modalSubscribed : {
                                        modal : false,
                                        modalName : "",
                                        link : createLink("subscription")
                                    }
                                }
                            });
                        }
                    }
                }

                // Rafraîchir les règles CASL à CHAQUE fetch porteur de rules : un changement
                // d'abonnement / d'essai (qui ne modifie PAS le rôle) doit mettre à jour les
                // permissions (ex. activer le trial Plus -> droit de créer story/sondage/repost).
                if(currentUser?.rules){
                    ability.update(currentUser.rules);
                }
                queryClient.setQueryData([USER_CURRENT_KEY], oldData => {
                    delete oldData.rules;
                    return oldData
                });
            },
            onError : (error) =>{
                const statusCode = _.get(error, 'statusCode');
                const errorMessage = _.get(error, 'message')
                    || _.get(error, 'data.message')
                    || _.get(error, 'response.data.message');
                if(statusCode === 403 && /banned/i.test(String(errorMessage))){
                    console.log("User banned (403), removing token");
                    logout();
                    return;
                }
                if(_.get(error, 'statusCode') === 404){
                    console.log("Token expired or user not found, redirecting to home");
                    logout();
                }
            }
        }
    );
}

export default useQueryCurrentUser;